import React, { memo } from 'react'

import { Button, classnames, FileFull, Icon, ImageAdd, Trash } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, bool, func, shape, string } from 'prop-types'

import { iconSize, iconSizeLarge } from 'Pods/ThreeDStudio/constants'

function ReferenceGrid({ references, onAdd, onRemove }) {
  return (
    <div className="visual-references__grid">
      {references.map((reference) => {
        const showImage = reference.isUploaded && reference.isImage && reference.thumbUrl

        return (
          <div
            key={reference.id}
            className={classnames(
              'visual-references__thumb',
              !reference.isUploaded && 'visual-references__thumb--uploading',
            )}
          >
            {showImage ? (
              <img
                src={reference.thumbUrl}
                alt={reference.name}
                className="visual-references__image"
                decoding="async"
              />
            ) : (
              <span className="visual-references__file" title={reference.name}>
                <Icon svgComponent={FileFull} color="dark" size={iconSizeLarge} notSpaced />
              </span>
            )}
            <Button
              type="ghost"
              variant="only-icon"
              actionType="button"
              customClass="visual-references__remove"
              onClick={() => onRemove(reference.name)}
              aria-label="Remove reference"
              icon={<Icon svgComponent={Trash} color="darker" size={iconSize} notSpaced />}
            />
          </div>
        )
      })}
      <Button
        type="ghost"
        variant="only-icon"
        actionType="button"
        customClass="visual-references__add"
        onClick={onAdd}
        aria-label="Add reference"
        expand
        icon={<Icon svgComponent={ImageAdd} color="dark" size={iconSizeLarge} notSpaced />}
      />
    </div>
  )
}

ReferenceGrid.propTypes = {
  references: arrayOf(shape({
    id: string.isRequired,
    name: string.isRequired,
    isImage: bool,
    thumbUrl: string,
    isUploaded: bool,
  })).isRequired,
  onAdd: func.isRequired,
  onRemove: func.isRequired,
}

export default memo(ReferenceGrid)
